import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import type { JSX } from 'react';
import { handleDisconnect } from '../Utils/HandleDisconnect';
import Typography from '@mui/material/Typography';
import type { Theme} from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import LocalStorageContext from '../Contexts/LocalStorageContext';
import type { ModeContextProps } from '../Contexts/ModeContext';
import ModeContext from '../Contexts/ModeContext';
import type { SystemContextProps } from '../Contexts/SystemContext';
import SystemContext from '../Contexts/SystemContext';
import type { ApiContextProps } from '../Contexts/ApiContext';
import ApiContext from '../Contexts/ApiContext';
import type { TokenContextProps } from '../Contexts/TokenContext';
import TokenContext from '../Contexts/TokenContext';
import type { UserContextProps } from '../Contexts/UserContext';
import UserContext from '../Contexts/UserContext';
import { useTitle } from 'shouldve-been-react';
import Button from '@mui/material/Button';

type ErrorPageProps = {
    errorMessage: string,
    canDisconnect: boolean,
};

function ErrorPage(props: Readonly<ErrorPageProps>): JSX.Element {

    useTitle('K-Fleet Purchase');

    const localStorageContext: LocalStorageContextProps = useContext<LocalStorageContextProps>(LocalStorageContext);
    const modeContext: ModeContextProps = useContext<ModeContextProps>(ModeContext);
    const systemContext: SystemContextProps = useContext<SystemContextProps>(SystemContext);
    const apiContext: ApiContextProps = useContext<ApiContextProps>(ApiContext);
    const tokenContext: TokenContextProps = useContext<TokenContextProps>(TokenContext);
    const userContext: UserContextProps = useContext<UserContextProps>(UserContext);

    const currentTheme: Theme = useTheme();

    function handleDisconnectPressed(): void {

        handleDisconnect(apiContext, modeContext, localStorageContext, userContext, tokenContext, systemContext);
    }

    return (
        <div style={{
            textAlign: 'center',
            padding: '105px 5px 5px 5px',
        }}>
            <FontAwesomeIcon
                icon={faTriangleExclamation}
                size='5x'
                color={currentTheme.palette.error.main}
            />
            <br />
            <br />
            <br />
            <Typography style={{
                color: currentTheme.palette.text.primary,
            }}>
                {props.errorMessage}
            </Typography>
            <br />
            <br />
            {props.canDisconnect &&
                <Button 
                    onClick={handleDisconnectPressed}
                    color='error'
                    variant='contained'
                    style={{
                        minWidth: '150px',
                        maxWidth: '150px',
                        minHeight: '40px',
                        maxHeight: '40px',
                        lineHeight: 'normal',
                    }}
                >
                    Disconnect
                </Button>
            }
        </div>
    );
}

export default ErrorPage;